export type ParsedInsuranceModifiedBy = {
	nickname?: string;
	name?: string;
	picture?: string;
};

export const parseInsuranceModifiedBy = (
	raw: unknown,
): ParsedInsuranceModifiedBy | null => {
	if (raw == null) {
		return null;
	}
	let obj: unknown = raw;
	if (typeof raw === "string") {
		const s = raw.trim();
		if (!s || s === "{}") {
			return null;
		}
		try {
			obj = JSON.parse(s) as unknown;
		} catch {
			return null;
		}
	}
	if (typeof obj !== "object" || obj === null) {
		return null;
	}
	const o = obj as Record<string, unknown>;
	if (Object.keys(o).length === 0) {
		return null;
	}
	return {
		nickname: typeof o.nickname === "string" ? o.nickname : undefined,
		name: typeof o.name === "string" ? o.name : undefined,
		picture: typeof o.picture === "string" ? o.picture : undefined,
	};
};

export const insuranceHasModificationHistory = (input: {
	modified_at?: string | null;
	modified_by?: unknown;
}): boolean => {
	const at = input.modified_at?.trim();
	if (!at) {
		return false;
	}
	const parsed = parseInsuranceModifiedBy(input.modified_by);
	return parsed != null;
};

export const formatInsuranceModifiedAt = (
	isoOrTimestamp: string,
	locale: string,
): string => {
	const d = new Date(isoOrTimestamp);
	if (Number.isNaN(d.getTime())) {
		return isoOrTimestamp;
	}
	return new Intl.DateTimeFormat(locale === "nb-NO" ? "nb-NO" : "en-GB", {
		dateStyle: "medium",
		timeStyle: "short",
	}).format(d);
};
